import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Switch } from '../ui/switch';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import ImageEditor from './ImageEditor';

const GalleryCardDialog = ({ open, onOpenChange, draft, setDraft, onSave, saving }) => {
  const isEdit = Boolean(draft.id);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-800 text-white max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{isEdit ? 'Edit gallery card' : 'New gallery card'}</DialogTitle>
          <DialogDescription className="text-gray-400">
            {isEdit ? 'Update this card’s details or images.' : 'Add a new card with title, category, description and images.'}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-gray-300">Title</Label>
            <Input
              data-testid="card-title-input"
              value={draft.title}
              onChange={(e) => setDraft({ ...draft, title: e.target.value })}
              className="bg-slate-800 border-slate-700 text-white"
              placeholder="e.g. Sig P320 Legion — Red Dot Install"
            />
          </div>
          <div>
            <Label className="text-gray-300">Category</Label>
            <Input
              data-testid="card-category-input"
              value={draft.category}
              onChange={(e) => setDraft({ ...draft, category: e.target.value })}
              className="bg-slate-800 border-slate-700 text-white"
              placeholder="e.g. Pistol Upgrades"
            />
          </div>
          <div>
            <Label className="text-gray-300">Description</Label>
            <Textarea
              data-testid="card-description-input"
              value={draft.description}
              onChange={(e) => setDraft({ ...draft, description: e.target.value })}
              className="bg-slate-800 border-slate-700 text-white"
              rows={3}
            />
          </div>
          <div>
            <Label className="text-gray-300">Images</Label>
            <ImageEditor
              images={draft.images}
              onChange={(images) => setDraft({ ...draft, images })}
            />
          </div>
          <div className="flex items-center gap-3">
            <Switch
              data-testid="card-visible-switch"
              checked={draft.visible}
              onCheckedChange={(v) => setDraft({ ...draft, visible: v })}
            />
            <Label className="text-gray-300">
              {draft.visible ? 'Visible on public gallery' : 'Hidden (draft)'}
            </Label>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-slate-700 text-white hover:bg-slate-800">
            Cancel
          </Button>
          <Button
            data-testid="card-save-button"
            onClick={onSave}
            disabled={saving || !draft.title.trim() || !draft.category.trim()}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {saving ? 'Saving…' : (isEdit ? 'Save changes' : 'Create card')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default GalleryCardDialog;
